export enum OrderReportColumn {
  reportName = 'reportName',
  reportType = 'reportType',
  generatedOn = 'generatedOn',
  share = 'share'
}
